import { Component } from '@angular/core';
import {Router} from '@angular/router';

declare var jQuery:any;

@Component({
    selector: 'navigation',
    templateUrl: 'navigation.template.html'
})

export class NavigationComponent {

    permisos:any=[];
    usuario: any = {};
    
    constructor(private router: Router) {
        
        var usuario = JSON.parse(localStorage.getItem("user"));
        this.permisos = usuario.permisos;
        this.usuario = usuario.datosPersona;
        
    }

    ngAfterViewInit() {
        jQuery('#side-menu').metisMenu();
    }

    activeRoute(routename: string): boolean{
        return this.router.url.indexOf(routename) > -1;
    }

    cerrarSesion(){
        
        localStorage.removeItem('currentUser');
        localStorage.removeItem('user');
        this.router.navigate(['login']);
        
    }

    validarPermiso(idPermiso){

        var band = false;
        for (let permiso of this.permisos) {

            if(permiso.id == idPermiso){
                band = true;
            }
        }

        return band;

    }

}


// WEBPACK FOOTER //
// ./src/app/components/common/navigation/navigation.component.ts